var phone_number = {};
module['exports'] = phone_number;
phone_number.formats = require("./formats");



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/vi/phone_number/index.js
 ** module id = 1086
 ** module chunks = 0
 **/